import { IAdvertRepository } from '../ports/IAdvertRepository';

export class DeleteAdvertUseCase {
  constructor(private repo: IAdvertRepository) {}
  execute(uuid: string): Promise<void> { return this.repo.delete(uuid); }
}
